import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import DrawingFiltering from 'components/system_commands/form_fields/DrawingFiltering.jsx';

const HiddenPartialsManager = ({ create_path }) => {
  const { register, formState: { errors } } = useForm();
  const [selectedDrawingIds, setSelectedDrawingIds] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const setValue = (_name, valueOrFunction) => {
    setSelectedDrawingIds(previous =>
      typeof valueOrFunction === 'function' ? valueOrFunction(previous) : valueOrFunction
    );
  };

  const csrfToken =
    document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';

  // Reset the parent's tracked selection on close so a future open never
  // submits IDs the user no longer thinks are picked, even if DrawingFiltering
  // changes how it broadcasts an empty internal selection.
  const closeModal = () => { setIsOpen(false); setSelectedDrawingIds([]); };
  const openModal = () => setIsOpen(true);

  useEffect(() => {
    if (!isOpen) { return; }
    const handleKey = (event) => {
      if (event.key === 'Escape') { closeModal(); }
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [isOpen]);

  return (
    <>
      <button type="button" onClick={openModal} className="btn btn-primary">
        + Yeni Kesit Gizle
      </button>

      {isOpen && (
        <div className="hidden-partials-modal-overlay" onClick={closeModal}>
          <div
            className="hidden-partials-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="hidden-partials-modal-title"
            onClick={event => event.stopPropagation()}
          >
            <header className="hidden-partials-modal__header">
              <h3 id="hidden-partials-modal-title">Yeni Kesit Gizle</h3>
              <button
                type="button"
                onClick={closeModal}
                className="hidden-partials-modal__close"
                aria-label="Kapat"
              >
                ×
              </button>
            </header>

            <div className="hidden-partials-modal__body">
              <p>
                Asagidaki filtreleme ile kesitleri bul ve sec. Sadece <code>kesit</code> (partial)
                cizimler listelenir.
              </p>
              <table style={{ width: '100%' }}>
                <tbody>
                  <DrawingFiltering
                    config={{
                      name: 'drawing_ids',
                      label: 'Cizim filtreleme',
                      placeholder: 'kesit',
                      force_filter_suffix: 'kesit',
                    }}
                    setValue={setValue}
                    register={register}
                    errors={errors}
                  />
                </tbody>
              </table>
            </div>

            <footer className="hidden-partials-modal__footer">
              <button type="button" onClick={closeModal} className="btn">
                Iptal
              </button>
              <form action={create_path} method="post" style={{ display: 'inline' }}>
                <input type="hidden" name="authenticity_token" value={csrfToken} />
                {selectedDrawingIds.map(id => (
                  <input key={id} type="hidden" name="drawing_ids[]" value={id} />
                ))}
                <button
                  type="submit"
                  disabled={selectedDrawingIds.length === 0}
                  className="btn btn-primary"
                >
                  Secilen kesitleri gizle ({selectedDrawingIds.length})
                </button>
              </form>
            </footer>
          </div>
        </div>
      )}
    </>
  );
};

export default HiddenPartialsManager;
